// Full-document render of the stearns ProductGridPage: PageSkeleton (the React
// document shell) wrapping the existing product-grid-page body island. The
// legacy template rendered the body inside <main> with the site header/footer
// intact; the "product-grid-page" body_class and CollectionPage-typed JSON-LD
// are carried in page_chrome.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductGridPageBody } from "../components/ProductGridPageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed with
// mutable reactivated props. The body template accepts Immutable props, to which
// these are assignable.
export const Template = (
    props: templates.ProductGridPageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProductGridPageBody page={props.page} />
    </PageSkeleton>
);
